export const creditCardRepaymentMethodChangeExternal = {
    targetClientId: '',
};
